import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-activation-success',
    standalone: true,
    imports: [RouterModule],
    templateUrl: './activation-success.component.html',
    styleUrl: './activation-success.component.scss'
})
export class ActivationSuccessComponent {

}
